<template>
  <div>
    <h1 class="hidden-sm-and-down">{{ titulo }}</h1>
    <h2 class="hidden-md-and-up">{{ titulo }}</h2>
  </div>
</template>

<script>
export default {
  props: {
    titulo: {
      type: String,
      default: ""
    }
  }
};
</script>
